import type { Routes } from '@angular/router';
import { swapCardResolver } from './resolvers/swap-card.resolver';

export const MAP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./map/map.component').then((m) => m.MapComponent),
  },
  {
    path: 'swap/:uuid',
    children: [],
    resolve: { _: swapCardResolver },
  },
] as const;
